import type { User } from "../../../slices/authSlice"
import AddApplicantBox from "./AddApplicantBox"
import { useEffect } from "react"
import InfoPopover from "../../ui/InfoPopover"

type ApplicantSectionProps = {
  hideHeader?: boolean;
  onChange?: (list: any[]) => void;
  orderingParty?: Partial<User> | null
  initialData?: any[] | null;
  disabled?: boolean
};

export default function ApplicantSection({
  hideHeader = false,
  onChange,
  initialData,
  orderingParty,
  disabled = false
}: ApplicantSectionProps) {

  useEffect(() => {
    const list = initialData || []
    const complete = list.length > 0

    window.dispatchEvent(
      new CustomEvent("sectionComplete", {
        detail: { section: "applicant", complete }
      })
    )
  }, [initialData])

  return (
    <section>

      {!hideHeader && (
        <>
          <div className="flex items-center gap-2 mb-2">
            <img
              src="/anmeldervertreter.svg"
              alt="Representative icon"
              className="w-6 h-6 shrink-0 brightness-0"
            />
            <h2 className="text-xl font-semibold text-gray-800">
              Applicant and Representative
            </h2>
          </div>

          <p className="text-sm text-gray-600 mb-4">
            Provide information about the applicant(s) and representative(s).
          </p>
        </>
      )}

      <div className="mb-8">
        <h3 className="mb-3 flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-wide text-gray-400">
          Ordering Party
          <InfoPopover text="Applicant or representative of client in home country; postal delivery address and invoice recipient" />
        </h3>

        <AddApplicantBox
          orderingParty={orderingParty}
          onChange={onChange}
          initialData={initialData || undefined}
          disabled={disabled}
        />
      </div>

      {!hideHeader && <hr className="border-t border-gray-200 mb-8" />}
    </section>
  )
}
